<!-->┌────┬─────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│ PA │                              Airblue Page                                       │<- ->
<- ->└────┴─────────────────────────────────────────────────────────────────────────────────┘<--->

<style lang="less" src=":/PA/styles/shared.less"></style>

<template>
    <page use-cms-folder="/Content/Layouts/Clean">
        <template v-slot:container>
            <slot />
        </template>
    </page>
</template>

<script>
    import Page from "@/common/page"

    export default {
        abstract: true,
        components: {
            Page: {
                ...Page,
                name: "AirbluePage"
            }
        }
    }
</script>